(async function trackPostcardUsed() {

    const showLog = true;

    function consoleLog(message) {
        if (showLog) {
            console.log(message);
        }
    }

    function sanitizeEmail(email) {
        const decodedEmail = atob(email);
        return decodedEmail.replace(/\s+/g, '+');
    }

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }
    function removeParam() {
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.delete("card_id");
   window.history.replaceState({}, document.title, urlObj.toString());
    }
    consoleLog('✅ Postcard QR Tracking started');

    const urlParams = new URLSearchParams(window.location.search);

    // Get email from query var ?card_id
    const email = urlParams.get('card_id');
    if (!email) {
        consoleLog('❌ No email found, skipping postcard QR tracking');
        return false;
    }

    // Sanitize and validate email
    const sanitizedEmail = sanitizeEmail(email);
    if (!isValidEmail(sanitizedEmail)) {
        consoleLog('❌ Invalid email format:', sanitizedEmail);
        return false;
    }

    // Check Klaviyo integration
    if (!klaviyo || !klaviyo.account) {
        consoleLog('❌ Klaviyo is not available, skipping postcard QR tracking');
        return false;
    }

    // Identify profile
    const resProfile = await klaviyo.identify({ email: sanitizedEmail });

    consoleLog('✅ Profile identified', sanitizedEmail);

    // Track event
    
        await klaviyo.track('Postcard QR Used', {
            'Postcard QR ID': email,
            'URL': `${window.location.origin}${window.location.pathname}`
        });
        consoleLog('✅ Event tracked', email);
        removeParam();

        


})();


